import { toast } from 'react-toastify';

export default function (text) {
  navigator.clipboard.writeText(text);

  toast(`${text} copied to clipboard!`, {
    type: toast.TYPE.SUCCESS,
  });
}
